import { DATE_FORMAT, TIME_FORMAT } from "constants"
import { dateTimeFunction } from "utils/date"

const clientCellTransform = (response, req, params) => {
  if (!params?.actionType.includes("includeLastUsed")) {
    return response
  }
  const tooltipTitle = d => {
    let date = dateTimeFunction({ date: d, format: DATE_FORMAT })
    let time = dateTimeFunction({ date: d, format: TIME_FORMAT })

    const tooltipTitle = `${date}, ${time}`
    return tooltipTitle
  }

  // swap the number that is last used with the first object
  for (let i = 0; i < response.length; i++) {
    if (response[i].lastUsed) {
      let temp = response[0]
      response[0] = response[i]
      response[i] = temp
      break
    }
  }

  return response?.map((e, index) => {
    return {
      number: e.number,
      lastUsed: e.lastUsed ? "Last Called" : "",
      lastUsedDateTime: e.lastUsedDateTime ? tooltipTitle(e.lastUsedDateTime) : "",
    }
  })
}

export default clientCellTransform
